
import makerjs from "makerjs";
function B15(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,T = Param[2].param,S1 = Param[3].param,  
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       s1 = S1 * 1 * myZoom,
        t = T * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = 0, x1 = b+s1-t, x2 =s1+b ,x3 =b , y0 = 0, y1 = l,y2 = l, y3 =0,glassH =l, glassW = s1+b,h=l,w=s1+b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  } if (s1 !== 0) {
    var TxtS1 = "S1="+S1;
  } if (t !== 0) {
    var TxtT = "T="+T;
  } 



   var drawAbnormalShapeB15 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "RightLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "BottomLine": new makerjs.paths.Line([x3,y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB15MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x0, y1], [x0- 2 * markShift, y1]),
        "RightShortDnline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB15MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x3, y3- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB15MarkS1 = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x2, y3- markShift], [x3, y3- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x2, y3], [x2, y3- 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3+ 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB15MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x1, y1+ markShift], [x2, y2+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x1, y1], [x1, y1 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB15MarkB, TxtB, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB15MarkL, TxtL, [x0-2*markShift, y0], [x0-2*markShift, y1]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB15MarkS1, TxtS1, [x3, y3-2*markShift], [x2, y3-2*markShift]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB15MarkT, TxtT, [x1, y1 + 2 * markShift], [x2, y2 + 2 * markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB15: drawAbnormalShapeB15,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB15: drawAbnormalShapeB15,
        drawAbnormalShapeB15MarkL: drawAbnormalShapeB15MarkL,
        drawAbnormalShapeB15MarkT: drawAbnormalShapeB15MarkT,
        drawAbnormalShapeB15MarkS1: drawAbnormalShapeB15MarkS1,
        drawAbnormalShapeB15MarkB:drawAbnormalShapeB15MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B15;